import {
  AddOutlined as AddOutlinedIcon,
  EditOutlined as EditOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon
} from '@mui/icons-material'
import { formatCLP } from '../../../Facturacion/utils/formatCLP'
import DataTable from '../../components/DataTable'
import { formatDate } from '../../utils/inventoryFormatters'

const ListStatusPill = ({ children }) => (
  <span className='inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700'>
    {children}
  </span>
)

const SalesNoteListView = ({ notes, onCreate, onPreview, onEdit }) => (
  <div className='space-y-4'>
    <div className='flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 md:flex-row md:items-center md:justify-between'>
      <div>
        <p className='text-xs font-semibold uppercase tracking-[0.14em] text-slate-500'>
          Explorar
        </p>
        <p className='mt-1 text-sm text-slate-600'>
          Revisa notas guardadas localmente en este navegador o crea una nueva nota de venta.
        </p>
      </div>

      <button
        type='button'
        onClick={onCreate}
        className='inline-flex items-center justify-center gap-1.5 rounded-lg bg-accent2 px-3 py-2 text-sm font-semibold text-white transition hover:bg-accent2/90'
      >
        <AddOutlinedIcon style={{ fontSize: '1rem' }} />
        Crear nota de venta
      </button>
    </div>

    <div className='rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900'>
      Las notas se guardan de forma local mientras no exista persistencia en backend.
    </div>

    <DataTable
      columns={['Código', 'Fecha', 'Cliente', 'Referencia', 'Items', 'Total', 'Estado', 'Acciones']}
      rows={notes}
      emptyText='Aún no hay notas de venta guardadas. Crea una nueva para comenzar.'
      renderRow={record => (
        <>
          <td className='px-4 py-3 align-top'>
            <div className='font-semibold text-slate-900'>{record.internalCode}</div>
            <div className='mt-1 text-xs text-slate-500'>Actualizada {formatDate(record.updatedAt)}</div>
          </td>
          <td className='px-4 py-3 align-top text-slate-700'>{formatDate(record.dateIssued)}</td>
          <td className='px-4 py-3 align-top'>
            <div className='font-medium text-slate-800'>{record.customerLabel}</div>
            <div className='mt-1 text-xs text-slate-500'>{record.customer?.rut || 'Sin RUT'}</div>
          </td>
          <td className='px-4 py-3 align-top text-slate-700'>{record.reference || 'Sin referencia'}</td>
          <td className='px-4 py-3 align-top text-slate-700'>{record.itemsCount}</td>
          <td className='px-4 py-3 align-top font-semibold text-slate-900'>
            {formatCLP(record.totalAmount)}
          </td>
          <td className='px-4 py-3 align-top'>
            <ListStatusPill>{record.status}</ListStatusPill>
          </td>
          <td className='px-4 py-3 align-top'>
            <div className='flex flex-wrap justify-end gap-2'>
              <button
                type='button'
                onClick={() => onPreview(record)}
                className='inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50'
              >
                <VisibilityOutlinedIcon style={{ fontSize: '0.9rem' }} />
                Ver
              </button>
              <button
                type='button'
                onClick={() => onEdit(record)}
                className='inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50'
              >
                <EditOutlinedIcon style={{ fontSize: '0.9rem' }} />
                Editar
              </button>
            </div>
          </td>
        </>
      )}
    />
  </div>
)

export default SalesNoteListView
